// @owners { team: patient-health }
// eslint-disable-next-line @alto/no-pocky-import
import { Button, DeprecatedModal, DeprecatedModalBody, DeprecatedModalFooter } from '@alto/pocky';
import React from 'react';

type Props = {
  readonly cancelTransfer: () => void;
  readonly toggleDeleteModal: () => void;
};

export const MedTransferModal = ({ cancelTransfer, toggleDeleteModal }: Props) => {
  return (
    <DeprecatedModal
      onClose={toggleDeleteModal}
      showing
      title="Cancel transfer Request"
    >
      <DeprecatedModalBody>Are you sure you want to cancel this transfer request?</DeprecatedModalBody>

      <DeprecatedModalFooter>
        <Button
          kind="secondary"
          onClick={toggleDeleteModal}
        >
          Back
        </Button>

        <Button
          danger
          kind="primary"
          onClick={cancelTransfer}
        >
          Cancel transfer
        </Button>
      </DeprecatedModalFooter>
    </DeprecatedModal>
  );
};
